import { resolveApiPath } from '@codametrix/ui-common';

export function fetchApi(input: string, init?: RequestInit): Promise<Response> {
  return fetch(resolveApiPath(input), init);
}
